<template>
  <div class="header-area">
    <MobileHeader v-if="commonStore.isMobile" ref="header" />
    <DesktopHeader
      v-if="commonStore.isDesktop"
      ref="header"
      :isLogo="props.logo"
    />
  </div>
</template>

<script setup lang="ts">
import MobileHeader from '@components/common/MobileHeader.vue';
import DesktopHeader from '@components/common/DesktopHeader.vue';
import { useCommonStore } from '@stores';

const props = defineProps<{
  logo: number;
}>();

const commonStore = useCommonStore();
</script>

<style scoped lang="scss"></style>
